/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./LoanReportTest.css";
import { ArrowLeftIcon, ArrowRightIcon } from "lucide-react";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50,100,"All"];
const API_URL = "https://payyug.in/api";

const ForceCloser = () => {
  const navigate = useNavigate();

  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [loanType, setLoanType] = useState("");

  const [loans, setLoans] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [showForceCloseModal, setShowForceCloseModal] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [emiList, setEmiList] = useState([]);
  const [forceCloseAmount, setForceCloseAmount] = useState(0);
  const [reason, setReason] = useState("");
  const [loadingClose, setLoadingClose] = useState(false);

  /* ================= FETCH Branch ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "all",
          },
        });
        setBranchs(res?.data.branches || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranch();
  }, []);

  /* ================= FETCH CENTERS ================= */
  useEffect(() => {
    if (!selectedBranch?.id) return;

    const fetchCenters = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        if (!superAdminId) return;

        const res = await axios.get(`${API_URL}/group/centre`, {
          params: {
            superAdminId,
            branchid: selectedBranch.id,
            limit: 100000,
          },
        });

        setCenters(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCenters();
  }, [selectedBranch]);

  /* ================= FETCH GROUPS ================= */
  useEffect(() => {
    if (!selectedCenter) return;

    const fetchGroups = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");

        const res = await axios.get(`${API_URL}/groupupdate/getall`, {
          params: {
            superAdminId,
            CenterId:
              selectedCenter.id === "all" ? "" : selectedCenter.id || "",
            limit: 100000,
          },
        });

        setGroups(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchGroups();
  }, [selectedCenter]);

  /* ================= FETCH LOANS ================= */
  const fetchLoans = async (page = 1, limit = rowsPerPage) => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("authToken");
      const superAdminId = localStorage.getItem("adminuserId");

      const res = await axios.get(`${API_URL}/group-loan/group/list`, {
        params: {
          superAdminId,
          branchId: selectedBranch?.id,
          centerId: selectedCenter?.id === "all" ? "" : selectedCenter?.id,
          groupId: selectedGroup?.id === "all" ? "" : selectedGroup?.id,
          loanType: loanType === "ALL" ? undefined : loanType,
          page,
          limit:limit==="All"?100000:limit,
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      const activeData = res.data?.data.filter(
        (a) => a.status.toLowerCase() === "active",
      );

      setLoans(activeData || res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
      setCurrentPage(res.data?.currentPage || 1);
    } catch (err) {
      setError("Failed to fetch loans");
    } finally {
      setLoading(false);
    }
  };

const fetchEmiList = async (loanAccountId) => {
  try {
    const token = localStorage.getItem("authToken");
    const adminId = localStorage.getItem("adminuserId");

    const res = await axios.get(
      `${API_URL}/group-loan/emi/list`,
      {
        params: {
          superAdminId: adminId ? Number(adminId) : 14,
          grouploanAccountId: loanAccountId,
          limit: 100000,
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const emi = res.data?.data || [];
    setEmiList(emi);

    const paid = emi.filter(x => x.status?.toLowerCase() === "paid");
    
    let pendingEmiNo = 1;
    
    if (paid.length > 0) {
      const lastPaid = paid[paid.length - 1];
      pendingEmiNo = Number(lastPaid.installmentNo || lastPaid.emiNo || 0) + 1;
    }

    const pending = emi.find(x => 
      Number(x.installmentNo) === pendingEmiNo || Number(x.emiNo) === pendingEmiNo
    );

    if (pending) {
      setForceCloseAmount(Number(pending.outstanding || 0));
    } else {
      setForceCloseAmount(0);
    }

  } catch (err) {
    console.error("EMI Fetch Error:", err);
    toast.error("Unable to fetch EMI.");
  }
};

  /* ================= HANDLE FORCE CLOSE SUBMIT ================= */
  const handleForceCloseSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      toast.error("Please enter a reason for closure.");
      return;
    }

    try {
      setLoadingClose(true);
      const token = localStorage.getItem("authToken");
      const adminId = localStorage.getItem("adminuserId") || 5;

      const payload = {
        loanAccountId: selectedLoan.id, 
        status: "FORCE_CLOSED",
        reason: reason,
        closureAmount: Number(forceCloseAmount),
        updatedBy: Number(adminId)
      };

      const res=await axios.post(`${API_URL}/group-loan/force-close-account`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(res.data?.message||"Loan Force Closed successfully!");
      setShowForceCloseModal(false);
      setReason("");
      
      // Refresh list
      fetchLoans(currentPage, rowsPerPage);
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to force close loan.");
    } finally {
      setLoadingClose(false);
    }
  };


  /* ================= FILTER ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedBranch || !selectedCenter) {
      toast.error("Please select Branch and Center before filtering.");
      return;
    }

    setCurrentPage(1);
    fetchLoans(1, rowsPerPage);
  };

  /* ================= ITEMS PER PAGE ================= */
  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    setRowsPerPage(value==="All"?"All":Number(value));
    setCurrentPage(1);

    if (selectedBranch && selectedCenter) {
      fetchLoans(1, value);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString("en-GB");
  };

  const filteredLoans =
    loanType === "" || loanType === "ALL"
      ? loans
      : loans.filter((loan) =>
          (loan.loanType || "")
            .toLowerCase()
            .startsWith(loanType.toLowerCase()),
        );

  return (
    <div className="loan-report-container">
      {/* Back wrapper */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        <ArrowLeftIcon
          onClick={() => navigate(-1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />

        <h2
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            color: "#333",
          }}
        >
          Group Loan Force Closer
        </h2>

        <ArrowRightIcon
          onClick={() => navigate(1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />
      </div>
      <section className="loan-report-filter-section">
        {/* <h2 className="loan-report-title">Force Closer Filter</h2>
        <p className="loan-report-subtitle">
          Use filter to see more precise report
        </p> */}

        <form className="loan-report-form" onSubmit={handleSubmit}>
          <div className="loan-report-grid">
            {/* Branch */}
            <div className="loan-report-form-group">
              <label>Select Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value),
                  );
                  setSelectedBranch(branch);
                  setSelectedCenter(null);
                  setSelectedGroup(null);
                  setLoans([]);
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Center */}
            <div className="loan-report-form-group">
              <label>Select Center</label>
              <select
                value={selectedCenter?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "all") {
                    setSelectedCenter({ id: "all", CenterName: "All" });
                  } else {
                    const center = centers.find((cn) => cn.id === Number(val));
                    setSelectedCenter(center);
                  }
                  setSelectedGroup(null);
                  setLoans([]);
                }}
              >
                <option value="">Select Center</option>
                <option value="all">All Centers</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            {/* Group */}
            <div className="loan-report-form-group">
              <label>Select Group</label>
              <select
                value={selectedGroup?.id || ""}
                disabled={!selectedCenter}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "all") {
                    setSelectedGroup({ id: "all", groupname: "All" });
                  } else {
                    const group = groups.find((gr) => gr.id === Number(val));
                    setSelectedGroup(group);
                  }
                  setLoans([]);
                }}
              >
                <option value="">Select Group</option>
                <option value="all">All Groups</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}
                  </option>
                ))}
              </select>
            </div>
            {/* Loan Type */}
            <div className="loan-report-form-group">
              <label>Loan Type</label>
              <select
                value={loanType}
                onChange={(e) => {
                  setLoanType(e.target.value);
                }}
              >
                <option value="ALL">All</option>
                <option value="FIXED">Fixed</option>
                <option value="INDIVIDUAL">Individual</option>
              </select>
            </div>
          </div>

          <button type="submit" className="loan-report-submit-btn">
            Filter
          </button>
        </form>
      </section>

      {/* ================= TABLE ================= */}
      <section className="loan-report-details-section">
        <div className="loan-report-table-header">
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={rowsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
        </div>

        <div className="loan-report-table-container">
          <table className="loan-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Loan Account No</th>
                <th>Center Name</th>
                <th>Group Name</th>
                <th>Member Name</th>
                <th>Loan Amount</th>
                <th>EMI Amount</th>
                <th>Total Payable</th>
                <th>Applied Date</th>
                <th>Approval Date</th>
                <th>Disbursal Date</th>
                <th>First Emi Date</th>
                <th>Loan Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="17">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="17">{error}</td>
                </tr>
              ) : filteredLoans.length === 0 ? (
                <tr>
                  <td colSpan="17">No data available</td>
                </tr>
              ) : (
                filteredLoans.map((loan, index) => {
                  const status = loan.status?.toLowerCase();

                  return (
                    <tr key={loan.id}>
                      <td>{rowsPerPage==="All"?index+1:(currentPage - 1) * rowsPerPage + index + 1}</td>
                      <td>{loan.loanAccountNumber || "N/A"}</td>
                      <td>{loan.centerName || "N/A"}</td>
                      <td>{loan.groupName || "N/A"}</td>
                      <td>{loan.memberName || "N/A"}</td>
                      <td>{loan.loanAmount || "N/A"}</td>
                      <td>{loan.loanEmiAmount || "N/A"}</td>
                      <td>{loan.loanPayable || "N/A"}</td>
                      <td>{formatDate(loan.loanAppliedDate)}</td>
                      <td>{formatDate(loan.approvalDate)}</td>
                      <td>{formatDate(loan.disbursalDate)}</td>
                      <td>{formatDate(loan.disbursedfirstDate)}</td>
                      <td>{loan.status || "N/A"}</td>

                      <td>
                        <button
                          className="force-close-action-btn"
                          onClick={() => {
                            setSelectedLoan(loan);
                            setShowForceCloseModal(true);
                            fetchEmiList(loan.id); 
                          }}
                        >
                          Force Close
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* ================= PAGINATION ================= */}
      {rowsPerPage!=="All" && totalPages > 1 && loans.length > 0 && (
        <div className="loan-report-pagination">
          <button
            onClick={() => {
              const newPage = currentPage - 1;
              setCurrentPage(newPage);
              fetchLoans(newPage, rowsPerPage);
            }}
            disabled={currentPage === 1}
          >
            ⬅ Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() => {
              const newPage = currentPage + 1;
              setCurrentPage(newPage);
              fetchLoans(newPage, rowsPerPage);
            }}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}

      {/* ================= FORCE CLOSE MODAL ================= */}
      {showForceCloseModal && selectedLoan && (
  <div className="pylf-modal-backdrop">
    <div className="pylf-modal-content">
      <div className="pylf-modal-header">
        <h3>Force Close Loan Account</h3>
        <button className="pylf-close-btn" onClick={() => setShowForceCloseModal(false)}>×</button>
      </div>
      
      <form onSubmit={handleForceCloseSubmit}>
        <div className="pylf-modal-body">
          {/* Loan Info Summary */}
          <div className="pylf-loan-summary-box">
            <p><strong>Account No:</strong> <span>{selectedLoan.loanAccountNumber}</span></p>
            <p><strong>Center Name:</strong> <span>{selectedLoan.centerName}</span></p>
            <p><strong>Group Name:</strong> <span>{selectedLoan.groupName}</span></p>
            <p><strong>Member Name:</strong> <span>{selectedLoan.memberName}</span></p>
            <p><strong>Loan Amount:</strong> <span>₹{selectedLoan.loanAmount}</span></p>
            {/* <p><strong>Total Payable:</strong> <span>₹{selectedLoan.loanPayable}</span></p> */}
          </div>

          <hr />

          {/* Dynamic data fetched from EMI List */}
          <div className="pylf-form-group">
            <label>Calculated Closure Amount (Outstanding)</label>
            <input 
              type="number" 
              value={forceCloseAmount} 
              disabled 
              className="pylf-disabled-input"
            />
            <small className="pylf-help-text">Based on the next pending EMI's outstanding amount.</small>
          </div>

          <div className="pylf-form-group">
            <label>Reason for Force Closure <span className="pylf-required">*</span></label>
            <select 
              value={reason} 
              onChange={(e) => setReason(e.target.value)}
              required
            >
              <option value="">-- Select Reason --</option>
              <option value="Customer Death">Customer Death</option>
              <option value="Pre-payment / Settled">Pre-payment / Settled</option>
              <option value="Bad Debt / Write Off">Bad Debt / Write Off</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {reason === "Other" && (
            <div className="pylf-form-group">
              <label>Specify Custom Reason</label>
              <input 
                type="text" 
                placeholder="Enter details..." 
                onChange={(e) => setReason(e.target.value)}
                required
              />
            </div>
          )}
        </div>

        <div className="pylf-modal-footer">
          <button type="button" className="pylf-btn-secondary" onClick={() => setShowForceCloseModal(false)}>
            Cancel
          </button>
          <button type="submit" className="pylf-btn-danger" disabled={loadingClose}>
            {loadingClose ? "Closing..." : "Confirm Force Close"}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default ForceCloser;